export type CreatorSocialPlatform = 'x' | 'youtube' | 'tiktok' | 'instagram' | 'facebook' | 'linkedin' | 'quora';

export type CreatorSocialLink = {
  platform: CreatorSocialPlatform;
  url: string;
};

export const creatorSocialMediaFields: Array<{ platform: CreatorSocialPlatform; validation: string }> = [
  { platform: 'x', validation: 'x.com/' },
  { platform: 'youtube', validation: 'youtube.com/@' },
  { platform: 'tiktok', validation: 'tiktok.com/@' },
  { platform: 'instagram', validation: 'instagram.com/' },
  { platform: 'facebook', validation: 'facebook.com/' },
  { platform: 'linkedin', validation: 'linkedin.com/in/' },
  { platform: 'quora', validation: 'quora.com/profile/' },
];

export const getCreatorSocialUsername = (value: string | undefined, index: number) => {
  const field = creatorSocialMediaFields[index];
  if (!value || !field) return '';

  const normalized = value
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .replace(/[?#].*$/, '')
    .replace(/\/$/, '');

  const username = normalized.toLowerCase().startsWith(field.validation.toLowerCase())
    ? normalized.slice(field.validation.length)
    : normalized;

  return username.replace(/^@/, '').replace(/^\/+|\/+$/g, '');
};

const addProtocol = (url: string) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);

const normalizeSocialUrl = (url: string) => {
  const socialUrl = new URL(addProtocol(url.trim()));
  socialUrl.protocol = 'https:';

  if (!socialUrl.hostname.startsWith('www.')) {
    socialUrl.hostname = `www.${socialUrl.hostname}`;
  }

  return socialUrl.toString();
};

export const buildCreatorSocialLinks = (socialMediaHandles: Array<string | undefined>): CreatorSocialLink[] =>
  socialMediaHandles
    .map((handle, index) => {
      const username = getCreatorSocialUsername(handle, index);
      const socialMediaField = creatorSocialMediaFields[index];

      if (!username || !socialMediaField) return null;

      return {
        platform: socialMediaField.platform,
        url: normalizeSocialUrl(`${socialMediaField.validation}${username}`),
      };
    })
    .filter((socialLink): socialLink is CreatorSocialLink => Boolean(socialLink));
